import { Calendar } from "lucide-react";
import { Button } from "@/components/ui/button";

export function SalesCtaPanel({ bookingUrl }: { bookingUrl: string }) {
  const open = () => {
    if (!bookingUrl) return;
    window.open(bookingUrl, "booking", "noopener,noreferrer,width=900,height=800");
  };
  return (
    <div className="flex h-full w-full items-center justify-center bg-accent/30 p-6 lg:p-10">
      <div className="max-w-md space-y-6 text-center">
        <div className="mx-auto flex h-16 w-16 items-center justify-center rounded-2xl bg-primary/10">
          <Calendar className="h-8 w-8 text-primary" />
        </div>
        <div className="space-y-2">
          <h2 className="text-2xl font-bold text-foreground">Talk to a human</h2>
          <p className="text-sm leading-relaxed text-muted-foreground">
            Want to go deeper or have specific questions? Book a meeting with one of our experts.
          </p>
        </div>
        <Button onClick={open} disabled={!bookingUrl} className="w-full" size="lg">
          <Calendar className="h-4 w-4" />Book a meeting
        </Button>
        <p className="text-xs text-muted-foreground">Opens a booking calendar in a new window.</p>
      </div>
    </div>
  );
}
